const SOURCE_PARAM = "source";
const SOURCE_VALUE = "tgp";

export const withTgpSource = (link: string): string => {
  if (!link) return link;
  try {
    const url = new URL(link, window.location.origin);
    url.searchParams.set(SOURCE_PARAM, SOURCE_VALUE);
    return url.toString();
  } catch {
    return link;
  }
};
